/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request to update proctored exam admission for one booking.
 */
export interface SetBookingAdmissionRequest {
  /** Whether the booking is admitted to the exam */
  admitted: boolean;
}
